import { render, staticRenderFns } from "./component-list.vue?vue&type=template&id=81b1e9ee&scoped=true&"
import script from "./component-list.vue?vue&type=script&lang=js&"
export * from "./component-list.vue?vue&type=script&lang=js&"
import style0 from "./component-list.vue?vue&type=style&index=0&id=81b1e9ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b1e9ee",
  null
  
)

export default component.exports